uniform sampler2D uDefaultTexture;
uniform sampler2D uDistortionTexture;
uniform vec2     uConvergencePosition;
uniform float    uDirection;
uniform bool     uColorChange;

varying vec2     vUv;

void main() {
  float w = texture(uDistortionTexture, vUv).r * uDirection;
  vec2 dir = uConvergencePosition - vUv;
  vec2 uvPrime = vUv + dir * w;
  vec4 color = texture(uDefaultTexture, uvPrime);
  if (uColorChange) {
    float r = color.b;
    float g = color.g;
    float b = color.r;
    r = pow(r, 1.2);
    g = pow(g, 1.1);
    b = pow(b, 0.9);
    color = vec4(r, g, b, color.a);
  }

  gl_FragColor = color;
}
